import React, { useEffect, useRef, useState } from "react";
import { style } from "./MainPage.css";
import {
  Box,
  Typography,
  Divider,
  Tooltip,
  TextField,
  InputAdornment,
  IconButton,
  AppBar,
  Toolbar,
  Drawer,
} from "@mui/material";
import ChatKonvergeLogo from "../Image/headingLogo.svg";
import UserImg from "../Image/headerUser.svg";
import KonvergeLogo from "../Image/konvergeLogo.svg";
import Facebook from "@mui/icons-material/Facebook";
import Twitter from "@mui/icons-material/Twitter";
import LinkedIn from "@mui/icons-material/LinkedIn";
import NearMeIcon from "@mui/icons-material/NearMe";
import Cards from "../Cards/Cards.component";
import { v4 as uuidv4 } from "uuid";
import Chat from "../Chat/Chat.component";
import PopUp from "../PopUp/PopUp.component";
import { Loading } from "react-loading-dot";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const MainPage = () => {
  const [exampleQuestions, setExampleQuestions] = useState("");
  const [showComponent, setshowComponent] = useState(true);
  const [questionSet, setQuestionSet] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [exampleAnswer, setExampleAnswer] = useState([]);
  const [counter, setCounter] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  const inputRef = useRef(null);

  const msgRef = useRef();
  const chatHandler = (e) => {
    setExampleQuestions(e.target.value);
  };

  const onTextfieldEnter = (e) => {
    if (e.code === "Enter") {
      textfieldHandler();
    }
  };

  useEffect(() => {
    window.sessionStorage.setItem(
      "data",
      JSON.stringify({ sessionid: uuidv4(), name: "", email: "", company: "" })
    );
    let data = JSON.parse(window.sessionStorage.getItem("data"));

    fetch(`${process.env.REACT_APP_BACKEND}/api/answer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        question: "",
        newconversation: true,
        sessionid: data.sessionid,
        name: data.name,
        email: data.email,
        company: data.company,
      }),
    });
  }, []);

  const textfieldHandler = (e) => {
    if (exampleQuestions.trim().length === 0) {
      return;
    }
    inputRef.current.disabled = true;

    if (counter === 2) {
      setOpen(true);
    } else {
      let data = JSON.parse(window.sessionStorage.getItem("data"));

      setshowComponent(false);
      if (exampleQuestions.trim().length !== 0) {
        setQuestionSet((prevMessages) => [...prevMessages, exampleQuestions]);
        setExampleQuestions("");

        setShowLoader(true);
        fetch(`${process.env.REACT_APP_BACKEND}/api/answer`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            question: exampleQuestions.trim(),
            newconversation: false,
            sessionid: data.sessionid,
            name: data.name,
            email: data.email,
            company: data.company,
          }),
        })
          .then((data) => data.json())
          .then((res) => {
            if (res.answer) {
              let showRes = res.answer
                .split(/(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]]+)/)
                .map((link) => {
                  if (link.startsWith("http")) {
                    return `<a href='${link}' target='_blank'>${link}</a>`;
                  } else {
                    link = link.replaceAll("\n", "<br />");
                    return link;
                  }
                });
              setExampleAnswer((prevMessages) => [
                ...prevMessages,
                showRes.join(""),
              ]);
              setShowLoader(false);
              inputRef.current.disabled = false;
              inputRef.current.focus();
              setCounter((preValue) => preValue + 1);
            }
            if (res["error"] === "") {
              let newExampleAnswer = JSON.parse(JSON.stringify(exampleAnswer));

              const text =
                "To unlock the power of our AI solutions and gain a competitive edge for your business, reach out to us at <a href='mailto:prateek@konverge.ai'>prateek@konverge.ai</a> or connect with us on <a href='https://linkedin.com/company/konverge-ai/' target=_blank>LinkedIn</a>. Visit our <a href='https://konverge.ai/contact/' target=_blank>website</a> for more details and to get in touch. We would be truly grateful for the opportunity to serve you and take your business to new heights!";

              newExampleAnswer.push(text);

              setExampleAnswer(newExampleAnswer);
              setShowLoader(false);
            }
          });
      }
    }
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  //function that is being called every time the drawer should open or close
  const toggleDrawer = (openDrawer) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    //changes the function state according to the value of open
    setOpenDrawer(openDrawer);
  };

  return (
    <Box sx={style.mainBox}>
      <Box sx={style.childBox}>
        <Box sx={style.mobileViewBox}>
          <AppBar position="static" sx={style.appBarHeader}>
            <Toolbar>
              <IconButton edge="start" color="inherit" aria-label="open drawer">
                <MenuIcon onClick={toggleDrawer(true)} sx={style.menuIcon} />
              </IconButton>
              <Box
                component="img"
                src={ChatKonvergeLogo}
                sx={style.chatKonvergeLogo}
              />
              <Drawer
                anchor="left"
                open={openDrawer}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                sx={style.leftDrawer}
              >
                <Box sx={style.letfBox}>
                  <IconButton sx={style.closeIconBtn}>
                    <CloseIcon onClick={toggleDrawer(false)} />
                  </IconButton>
                  <Box>
                    <Box component="img" src={UserImg} sx={style.userHeader} />
                    <Typography sx={style.leftText}>
                      Konverge is a boutique for creating the AI solution and
                      Data engineering products. We provide end to end service
                      for all the AI solution. We do whatever it takes to enable
                      the AI capabilities for your organization.
                    </Typography>
                    <Box sx={style.bottomBox}>
                      <Typography
                        sx={style.bottomText}
                        onClick={() => window.open("https://konverge.ai/blog/")}
                      >
                        Blogs
                      </Typography>
                      <Typography sx={style.pipe}>|</Typography>
                      <Typography
                        sx={style.bottomText}
                        onClick={() =>
                          window.open("https://konverge.ai/case-studies/")
                        }
                      >
                        Case Study
                      </Typography>
                    </Box>
                    <Box sx={style.iconsBox}>
                      <Tooltip title="Facebook">
                        <Facebook
                          src={Facebook}
                          sx={style.icons}
                          onClick={() =>
                            window.open("https://www.facebook.com/KonvergeAI/")
                          }
                        />
                      </Tooltip>
                      <Tooltip title="Twitter">
                        <Twitter
                          src={Twitter}
                          sx={style.icons}
                          onClick={() =>
                            window.open("https://twitter.com/KonvergeAI")
                          }
                        />
                      </Tooltip>
                      <Tooltip title="LinkedIn">
                        <LinkedIn
                          src={LinkedIn}
                          sx={style.icons}
                          onClick={() =>
                            window.open(
                              "https://linkedin.com/company/konverge-ai/"
                            )
                          }
                        />
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </Drawer>
            </Toolbar>
          </AppBar>
        </Box>

        <Box sx={style.webBox}>
          <Box
            component="img"
            src={ChatKonvergeLogo}
            sx={style.chatKonvergeLogo}
          />
          <Box component="img" src={UserImg} sx={style.userHeader} />
          <Typography sx={style.leftText}>
            Konverge is a boutique for creating the AI solution and Data
            engineering products. We provide end to end service for all the AI
            solution. We do whatever it takes to enable the AI capabilities for
            your organization.
          </Typography>
          <Box sx={style.createdMainBox}>
            <Divider orientation="horizontal" sx={style.divider} />
            <Box sx={style.createdTextBox}>
              <Typography sx={style.createdByText}>Created by</Typography>
              <Box
                component="img"
                src={KonvergeLogo}
                sx={style.konvergeLogo}
                onClick={() => window.open("https://konverge.ai/")}
              />
            </Box>
            <Divider orientation="horizontal" sx={style.divider} />
          </Box>
          <Box sx={style.bottomBox}>
            <Typography
              sx={style.bottomText}
              onClick={() => window.open("https://konverge.ai/blog/")}
            >
              Blogs
            </Typography>
            <Typography sx={style.pipe}>|</Typography>
            <Typography
              sx={style.bottomText}
              onClick={() => window.open("https://konverge.ai/case-studies/")}
            >
              Case Study
            </Typography>
          </Box>
          <Box sx={style.iconsBox}>
            <Tooltip title="Facebook">
              <Facebook
                src={Facebook}
                sx={style.icons}
                onClick={() =>
                  window.open("https://www.facebook.com/KonvergeAI/")
                }
              />
            </Tooltip>
            <Tooltip title="Twitter">
              <Twitter
                src={Twitter}
                sx={style.icons}
                onClick={() => window.open("https://twitter.com/KonvergeAI")}
              />
            </Tooltip>
            <Tooltip title="LinkedIn">
              <LinkedIn
                src={LinkedIn}
                sx={style.icons}
                onClick={() =>
                  window.open("https://linkedin.com/company/konverge-ai/")
                }
              />
            </Tooltip>
          </Box>
        </Box>
       <Box sx={style.rightPart}>
            {showComponent ? (
              <Box>
                <Cards setExampleQuestions={setExampleQuestions} />
              </Box>
            ) : (
              <Box sx={style.chatBox}>
                {questionSet.map((message, index) => {
                  return (
                    <Chat
                      key={index}
                      message={message}
                      exampleAnswer={exampleAnswer[index]}
                      showLoader={showLoader}
                      msgRef={msgRef}
                    />
                  );
                })}
                {showLoader && (
                  <Box sx={style.loader}>
                    <Loading size="10px" margin="1px" background="#020067" />
                  </Box>
                )}
              </Box>
            )}{" "}
          <Box sx={style.footerDiv}>
            <TextField
              value={exampleQuestions}
              inputRef={inputRef}
              sx={style.textField}
              type="text"
              placeholder="Write your question here..."
              onChange={(e) => chatHandler(e)}
              onKeyUp={onTextfieldEnter}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={textfieldHandler}>
                      <NearMeIcon sx={style.nearMeIcon} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={style.footer}>
              <Typography>Created by</Typography>
              <Box
                component="img"
                src={KonvergeLogo}
                sx={style.konvergeLogo}
                onClick={() => window.open("https://konverge.ai/")}
              />
            </Box>
          </Box>
            </Box> 
      </Box>
      <PopUp
        open={open}
        setOpen={setOpen}
        setCounter={setCounter}
        inputRef={inputRef}
      />
    </Box>
  );
};

export default MainPage;
